var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"plc-main",attrs:{"element-loading-background":"rgba(255, 255, 255, 0.8)"}},[(!_vm.loading)?_c('Content'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }